<template>
  <div>
    <v-dialog scrollable :fullscreen="fullscreen" v-model="dialog" width="1100">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Diagram <v-spacer></v-spacer>
          <v-select
            v-model="view_selected"
            :items="view"
            item-text="text"
            item-value="value"
            dense
            label="มุมมอง"
            outlined
            @change="getDiagram()"
          ></v-select>
        </v-card-title>
        <v-card-text
          class="d-flex justify-center pa-12"
          style="letter-spacing: 0; text-align: -webkit-center"
          ref="diagram"
        >
          <VueFlowy :chart="chart"></VueFlowy>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#033666" text @click="getDiagram">Reload diagram</v-btn>
          <v-btn color="#033666" text @click="fullscreen = !fullscreen">
            {{ fullscreen ? "Exit" : "Fullscreen" }}
          </v-btn>
          <v-btn
            v-if="!fullscreen"
            color="#033666"
            text
            @click="dialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 110px 0px 110px',
      }"
    >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title style="color: #395da5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-6"
                    :to="{
                      name: 'survey',
                    }"
                    @click="
                      $router.push({
                        name: 'survey',
                      })
                    "
                    >keyboard_double_arrow_left</v-icon
                  >
                </template>
                <span>กลับหน้าแรก</span>
              </v-tooltip>
              {{ $route.params.surveyName }}
            </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-row>
        <v-col class="pa-0 grow">
          <v-card flat color="transparent">
            <v-card-title> Survey </v-card-title>
          </v-card></v-col
        >
        <v-col class="shrink"
          ><v-btn color="#033666" dark @click.stop="Open">
            <span style="font-size: 12px">Diagram</span>
          </v-btn></v-col
        ></v-row
      >
      <br />
      <v-card flat color="transparent">
        <v-card-actions class="px-0">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            label="ค้นหา.."
            single-line
            solo
          >
            <v-icon slot="prepend-inner" class="mr-3">mdi-magnify</v-icon>
          </v-text-field>
        </v-card-actions>
      </v-card>
      <v-card flat width="100%" color="transparent">
        <Connect
          :questionlist="storeQuestion.connect"
          :JumpQuestion="JumpQuestion"
          :surveyStatus="surveyStatus"
        />
        <End :questionlist="storeQuestion.end" :surveyStatus="surveyStatus" />
        <Fail :questionlist="storeQuestion.fail" :surveyStatus="surveyStatus" />
      </v-card>
    </v-container>
  </div>
</template>

<script
  src="https://cdn.jsdelivr.net/npm/file-saver@2.0.2/dist/FileSaver.min.js"
  integrity="sha256-u/J1Urdrk3nCYFefpoeTMgI5viU1ujCDu2fXXoSJjhg="
  crossorigin="anonymous"
></script>
<script>
import Connect from "../../components/QuestionUI/Connect";
import End from "../../components/QuestionUI/End";
import Fail from "../../components/QuestionUI/Fail";
import Swal from "sweetalert2";
import { VueFlowy, FlowChart } from "vue-flowy";
import html2canvas from "html2canvas";
export default {
  components: { Connect, End, Fail, VueFlowy },
  data() {
    return {
      search: "",
      dialog: false,
      fullscreen: false,
      show: false,
      chart: new FlowChart({ direction: "TB" }),
      count: 1,
      freetext: [],
      fixtext: [],
      number: [],
      multiselect: [],
      view_selected: "LR",
      view: [
        {
          text: "บนลงล่าง",
          value: "TB",
        },
        {
          text: "ซ้ายไปขวา",
          value: "LR",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("CheckPermission").then((resp_role) => {
      if (resp_role.data.permission) {
        if (Object.keys(resp_role.data.permission).length !== 0) {
          this.$store.commit("UpdateUserPermission", resp_role.data);
        }
      }
    });
    this.$store.dispatch("getQuestionLabel", this.$route.params);
    this.$vuetify.goTo(0, {
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
    });
  },
  computed: {
    FlowStyle() {
      return this.view_selected === "LR";
    },
    storeQuestion() {
      let allquestion = this.$store.state.allquestion;
      allquestion.map((q) => {
        q.show = true;
      });
      if (typeof this.search != "object") {
        if (this.search !== null && this.search !== "") {
          allquestion.map((search) => {
            search.show = new RegExp(this.search.toUpperCase()).test(
              search.questionLabel.toUpperCase()
            );
          });
        }
      }
      let connect = [];
      let end = [];
      let fail = [];
      allquestion.map((question) => {
        switch (question.questionType) {
          case "fail":
            {
              fail.push(question);
            }
            break;
          case "end":
            {
              end.push(question);
            }
            break;

          default:
            {
              connect.push(question);
            }
            break;
        }
      });
      connect.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      end.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      fail.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      return { connect: connect, end: end, fail: fail };
    },
    JumpQuestion() {
      return {
        connect: this.storeQuestion.connect,
        end: this.storeQuestion.end,
      };
    },
    surveyStatus() {
      let survey = this.$store.state.surveylist.find(
        (id) => id.surveyID === this.$route.params.surveyID
      );
      if (survey) {
        return survey.surveyStatus;
      }
      return false;
    },
    operationlist() {
      return this.$store.state.operation;
    },
    Editing() {
      return this.$store.state.editing;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.Editing) {
      Swal.fire({
        text: `คุณมีการแก้ไข "${this.$store.state.editingPreData?.questionLabel}" ค้างไว้ คุณยังต้องการแก้ไขอยู่หรือไม่`,
        icon: "warning",
        focusConfirm: false,
        focusCancel: false,
        focusDeny: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonColor: "#F06FAF",
        denyButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "บันทึก",
        denyButtonText: "ไม่บันทึก",
        cancelButtonText: "กลับไปแก้ไข",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.state.editingCurrent = null;
          this.$store.state.editingConfirm.edit = true;
          let vm = this;
          const edited = setInterval(() => {
            if (!vm.Editing) {
              vm.$store.commit("UpdateQuestionPreEditing", null);
              next();
              clearInterval(edited);
            } else if (!vm.$store.state.editingConfirm.edit) {
              clearInterval(edited);
            }
          }, 0);
        } else if (result.isDenied) {
          this.$store.dispatch("getQuestionLabel", this.$route.params);
          this.$store.dispatch(
            "getQuestionPermission",
            this.$route.params.surveyID
          );
          this.$store.commit("UpdateQuestionPreEditing", null);
          this.$store.commit("ToggleEditing");
          next();
        } else {
          // next(false);
          this.$store.commit("BacktoEditing");
        }
      });
    } else {
      this.$store.commit("UpdateQuestionPreEditing", null);
      this.$store.state.editingCurrent = null;
      next();
    }
  },
  methods: {
    exportToImage() {
      const diagramElement = document.querySelector(".flow-chart"); // Replace with the actual reference to your diagram element
      const clone = diagramElement.cloneNode(true);
      document.querySelector("#temphtml").appendChild(clone);
      console.log("before", document.querySelector("#temphtml"));
      setTimeout(async () => {
        const canvas = await html2canvas(document.querySelector("#temphtml"));
        // document.body.appendChild("");
        // console.log("after", document.body);
        const image = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.setAttribute(
          "download",
          this.$route.params.surveyName + "-diagram.png"
        );
        a.setAttribute("href", image);
        a.click();
      }, 1000);
    },
    Open() {
      this.dialog = true;
      let vm = this;
      setTimeout(function () {
        vm.getDiagram();
      }, 500);
    },
    Fullscreen(element) {
      element = element || document.body;
      var full =
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        document.mozFullScreen ||
        document.webkitIsFullScreen;
      var requestScreen;

      if (full) {
        element = document;
        requestScreen =
          element.cancelFullScreen ||
          element.webkitCancelFullScreen ||
          element.mozCancelFullScreen ||
          element.exitFullscreen;
      } else {
        requestScreen =
          element.requestFullScreen ||
          element.webkitRequestFullScreen ||
          element.mozRequestFullScreen ||
          element.msRequestFullScreen;
      }

      if (requestScreen) {
        // Native full screen.
        requestScreen.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    FormatCondition(questioninfo) {
      if (questioninfo) {
        switch (questioninfo.conditionType) {
          case "freetext":
            {
              let data = {
                hascompute: false,
                defaultCondition: {
                  nextQuestionID: null,
                  score: 0,
                },
                computeCondition: {
                  match: [],
                  notmatch: {
                    nextQuestionID: null,
                    score: 0,
                  },
                },
              };
              let conditions;
              conditions = questioninfo.conditionsAnswer;
              let match = conditions.match;
              if (match.length === 1) {
                if (Object.keys(match[0].score).length === 0) {
                  data.defaultCondition.nextQuestionID =
                    match[0].nextQuestionID;
                  data.defaultCondition.score = match[0].value;
                } else {
                  data.hascompute = true;
                  data.computeCondition.match.push({
                    nextQuestionID: match[0].nextQuestionID,
                    operation: match[0].score.operation,
                    value: match[0].score.value[0],
                    value_from: match[0].score.value[0],
                    value_to:
                      match[0].score.operation === "><" ||
                      match[0].score.operation === "<>"
                        ? match[0].score.value[1]
                        : 0,
                    score: match[0].value,
                  });
                }
              } else {
                data.hascompute = true;
                let notmatch = match.find((c) => c.score.operation === "!!");
                if (notmatch) {
                  data.computeCondition.notmatch.nextQuestionID =
                    notmatch.nextQuestionID;
                  data.computeCondition.notmatch.score = notmatch.value;
                }
                this.$delete(
                  match,
                  match.findIndex((c) => c.score.operation === "!!")
                );
                match.map((cond) => {
                  data.computeCondition.match.push({
                    nextQuestionID: cond.nextQuestionID,
                    operation: cond.score.operation,
                    value: cond.score.value[0],
                    value_from: cond.score.value[0],
                    value_to:
                      cond.score.operation === "><" ||
                      cond.score.operation === "<>"
                        ? cond.score.value[1]
                        : 0,
                    score: cond.value,
                  });
                });
              }
              // console.log(conditions);
              // console.log(data);
              questioninfo.conditionsAnswer = data;
              this.freetext.push(questioninfo);
            }
            break;
          case "fixtext":
            {
              let tempfixtext = [];
              let conditions;
              conditions = questioninfo.conditionsAnswer;
              let match = conditions.match;
              let allname = [];
              match.map((cond) => {
                let data = {
                  fixtext: "",
                  hascompute: false,
                  defaultCondition: {
                    nextQuestionID: null,
                    score: 0,
                  },
                  computeCondition: {
                    match: [],
                    notmatch: {
                      nextQuestionID: null,
                      score: 0,
                    },
                  },
                };
                let fixname = cond.fixtext[0];
                let dup = tempfixtext.find((text) => text.fixtext === fixname);
                if (dup) {
                  if (cond.score.operation === "!!") {
                    dup.computeCondition.notmatch.nextQuestionID =
                      cond.nextQuestionID;
                    dup.computeCondition.notmatch.score = cond.value;
                  } else {
                    dup.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                    });
                  }
                } else {
                  data.fixtext = fixname;
                  if (Object.keys(cond.score).length === 0) {
                    data.defaultCondition.nextQuestionID = cond.nextQuestionID;
                    data.defaultCondition.score = cond.value;
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: "",
                      value: 0,
                      value_from: 0,
                      value_to: 0,
                      score: cond.value,
                    });
                  } else {
                    data.hascompute = true;
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                    });
                  }
                  tempfixtext.push(data);
                }
                allname.push(fixname);
              });
              // console.log(tempfixtext);
              questioninfo.conditionsAnswer = tempfixtext;
              this.fixtext.push(questioninfo);
            }
            break;
          case "number":
            {
              let tempnumber = [];
              let conditions;
              conditions = questioninfo.conditionsAnswer;
              let match = conditions.match;
              let allname = [];
              match.map((cond) => {
                // console.log(cond);
                let data = {
                  number: {
                    operation: "",
                    value: 0,
                    value_from: 0,
                    value_to: 0,
                  },
                  numbertext: "",
                  hascompute: false,
                  defaultCondition: {
                    nextQuestionID: null,
                    score: 0,
                    scoreInput: false,
                  },
                  computeCondition: {
                    match: [],
                    notmatch: {
                      nextQuestionID: null,
                      score: 0,
                    },
                  },
                };
                data.number.operation = cond.number.operation;
                data.number.value = cond.number.value[0];
                data.number.value_from = cond.number.value[0];
                data.number.value_to =
                  cond.number.operation === "><" ||
                  cond.number.operation === "<>"
                    ? cond.number.value[1]
                    : 0;
                let fixname = `${data.number.operation}|${
                  data.number.operation === "><" ||
                  data.number.operation === "<>"
                    ? `${data.number.value_from}|${data.number.value_to}`
                    : data.number.value
                }`;
                let dup = tempnumber.find(
                  (text) => text.numbertext === fixname
                );
                if (dup) {
                  if (cond.score.operation === "!!") {
                    dup.computeCondition.notmatch.nextQuestionID =
                      cond.nextQuestionID;
                    dup.computeCondition.notmatch.score = cond.value;
                    dup.defaultCondition.scoreInput = cond.valueInput;
                  } else {
                    dup.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                    });
                  }
                } else {
                  data.numbertext = fixname;
                  if (Object.keys(cond.score).length === 0) {
                    data.defaultCondition.nextQuestionID = cond.nextQuestionID;
                    data.defaultCondition.score = cond.value;
                    data.defaultCondition.scoreInput = cond.valueInput;
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: "",
                      value: 0,
                      value_from: 0,
                      value_to: 0,
                      score: cond.value,
                    });
                  } else {
                    data.hascompute = true;
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                    });
                  }
                  tempnumber.push(data);
                }
                allname.push(fixname);
              });
              // console.log(tempnumber);
              questioninfo.conditionsAnswer = tempnumber;
              this.number.push(questioninfo);
              // console.log("number");
            }
            break;
          case "multiselect":
            {
              let data = {
                hascompute: false,
                defaultCondition: {
                  nextQuestionID: null,
                  score: 0,
                },
                computeCondition: {
                  match: [],
                  notmatch: {
                    nextQuestionID: null,
                    score: 0,
                  },
                },
              };
              let conditions;
              conditions = questioninfo.conditionsAnswer;
              let match = conditions.match;
              if (match.length === 1) {
                if (Object.keys(match[0].score).length === 0) {
                  data.defaultCondition.nextQuestionID =
                    match[0].nextQuestionID;
                  data.defaultCondition.score = match[0].value;
                } else {
                  data.hascompute = true;
                  data.computeCondition.match.push({
                    nextQuestionID: match[0].nextQuestionID,
                    operation: match[0].score.operation,
                    value: match[0].score.value[0],
                    value_from: match[0].score.value[0],
                    value_to:
                      match[0].score.operation === "><" ||
                      match[0].score.operation === "<>"
                        ? match[0].score.value[1]
                        : 0,
                    score: match[0].value,
                  });
                }
              } else {
                data.hascompute = true;
                let notmatch = match.find((c) => c.score.operation === "!!");
                if (notmatch) {
                  data.computeCondition.notmatch.nextQuestionID =
                    notmatch.nextQuestionID;
                  data.computeCondition.notmatch.score = notmatch.value;
                }
                this.$delete(
                  match,
                  match.findIndex((c) => c.score.operation === "!!")
                );
                match.map((cond) => {
                  data.computeCondition.match.push({
                    nextQuestionID: cond.nextQuestionID,
                    operation: cond.score.operation,
                    value: cond.score.value[0],
                    value_from: cond.score.value[0],
                    value_to:
                      cond.score.operation === "><" ||
                      cond.score.operation === "<>"
                        ? cond.score.value[1]
                        : 0,
                    score: cond.value,
                  });
                });
              }
              // console.log(conditions);
              // console.log(data);
              questioninfo.conditionsAnswer = data;
              this.multiselect.push(questioninfo);
            }
            break;
        }
      }
    },
    async getDiagram() {
      this.freetext = [];
      this.fixtext = [];
      this.number = [];
      this.multiselect = [];
      let qs2e = [...this.storeQuestion.connect, ...this.storeQuestion.end];
      let question = [];
      for (const key in qs2e) {
        const element = qs2e[key];
        let questioninfo = await this.$store.dispatch(
          "getQuestionInfo",
          element.questionID
        );
        if (Object.keys(questioninfo).length > 0) {
          delete questioninfo.questionLabel;
          question.push({ ...element, ...questioninfo });
          await this.FormatCondition({ ...element, ...questioninfo });
        }
      }
      this.count++;
      document.querySelectorAll("#f").forEach((e) => {
        e.remove();
      });
      this.chart = new FlowChart({ direction: this.view_selected });
      const start = this.chart.addElement(`Start_${Date.now()}_${this.count}`, {
        label: "Start",
      });
      const end = this.chart.addElement(`End_${Date.now()}_${this.count}`, {
        label: "End",
      });
      let allnode = [
        ...this.freetext,
        ...this.fixtext,
        ...this.number,
        ...this.multiselect,
        ...this.storeQuestion.end,
      ];
      allnode.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      // console.log(allnode);
      allnode.map((q) => {
        if (q.questionType === "end") {
          q.node = this.chart.addElement(
            `${q.questionLabel}_${q.questionID}_${Date.now()}_${this.count}`,
            {
              label:
                q.questionLabel.length > 18
                  ? `${q.questionLabel.substring(0, 18)}...`
                  : q.questionLabel,
            }
          );
          q.nextnode = [];
        } else {
          switch (q.conditionType) {
            case "freetext":
              {
                q.node = this.chart.addElement(
                  `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                    this.count
                  }`,
                  {
                    label:
                      q.questionLabel.length > 18
                        ? `${q.questionLabel.substring(0, 18)}...`
                        : q.questionLabel,
                  }
                );
                if (q.conditionsAnswer.hascompute) {
                  q.conditionsAnswer.computeCondition.notmatch.node =
                    this.chart.addElement(
                      `${q.questionLabel}_${
                        q.questionID
                      }_${Date.now()}_freetext_notmatch_node_${this.count}`,
                      {
                        label: "ไม่ตรงเงื่อนไข",
                      }
                    );
                  q.conditionsAnswer.computeCondition.match.map((c, ic) => {
                    let operationtext = this.operationlist.find(
                      (op) => op.operation === c.operation
                    );
                    let opname = `คะแนน: ${operationtext.text} ${
                      c.operation === "><" || c.operation === "<>"
                        ? `${c.value_from} และ ${c.value_to}`
                        : c.value
                    }`;
                    c.node = this.chart.addElement(
                      `${q.questionLabel}_${
                        q.questionID
                      }_${Date.now()}_freetext_${ic}_${Date.now()}_${
                        c.operation
                      }_${this.count}`,
                      {
                        label: opname,
                      }
                    );
                  });
                }
              }
              break;
            case "fixtext":
              {
                q.node = this.chart.addElement(
                  `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                    this.count
                  }`,
                  {
                    label:
                      q.questionLabel.length > 18
                        ? `${q.questionLabel.substring(0, 18)}...`
                        : q.questionLabel,
                  }
                );
                q.conditionsAnswer.map((c, ic) => {
                  c.node = this.chart.addElement(
                    `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                      c.fixtext
                    }_${ic}_${Date.now()}_${this.count}`,
                    {
                      label:
                        c.fixtext.length > 18
                          ? `${c.fixtext.substring(0, 18)}...`
                          : c.fixtext,
                    }
                  );
                  if (c.hascompute) {
                    c.computeCondition.notmatch.node = this.chart.addElement(
                      `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                        c.fixtext
                      }_${ic}_${Date.now()}_notmatch_node_${this.count}`,
                      {
                        label: "ไม่ตรงเงื่อนไข",
                      }
                    );
                    c.computeCondition.match.map((cp, icp) => {
                      let operationtext = this.operationlist.find(
                        (op) => op.operation === cp.operation
                      );
                      let opname = `คะแนน: ${operationtext.text} ${
                        cp.operation === "><" || cp.operation === "<>"
                          ? `${cp.value_from} และ ${cp.value_to}`
                          : cp.value
                      }`;
                      cp.node = this.chart.addElement(
                        `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                          c.fixtext
                        }_${ic}_${Date.now()}_${
                          cp.operation
                        }_${icp}_${Date.now()}_${this.count}`,
                        {
                          label: opname,
                        }
                      );
                    });
                  }
                });
              }
              break;
            case "number":
              {
                q.node = this.chart.addElement(
                  `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                    this.count
                  }`,
                  {
                    label:
                      q.questionLabel.length > 18
                        ? `${q.questionLabel.substring(0, 18)}...`
                        : q.questionLabel,
                  }
                );
                q.conditionsAnswer.map((c, ic) => {
                  let operationtext = this.operationlist.find(
                    (op) => op.operation === c.number.operation
                  );
                  let opname = `คำตอบ: ${operationtext.text} ${
                    c.number.operation === "><" || c.number.operation === "<>"
                      ? `${c.number.value_from} และ ${c.number.value_to}`
                      : c.number.value
                  }`;
                  c.node = this.chart.addElement(
                    `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                      c.numbertext
                    }_${ic}_${Date.now()}_${this.count}`,
                    {
                      label: opname,
                    }
                  );
                  if (c.hascompute) {
                    c.computeCondition.notmatch.node = this.chart.addElement(
                      `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                        c.numbertext
                      }_${ic}_${Date.now()}_notmatch_node_${this.count}`,
                      {
                        label: "ไม่ตรงเงื่อนไข",
                      }
                    );
                    c.computeCondition.match.map((cp, icp) => {
                      let operationtext = this.operationlist.find(
                        (op) => op.operation === cp.operation
                      );
                      let opname = `คะแนน: ${operationtext.text} ${
                        cp.operation === "><" || cp.operation === "<>"
                          ? `${cp.value_from} และ ${cp.value_to}`
                          : cp.value
                      }`;
                      cp.node = this.chart.addElement(
                        `${q.questionLabel}_${
                          q.questionID
                        }_${Date.now()}_number_${ic}_${Date.now()}_${
                          cp.operation
                        }_${icp}_${Date.now()}_${this.count}`,
                        {
                          label: opname,
                        }
                      );
                    });
                  }
                });
              }
              break;
            case "multiselect":
              {
                q.node = this.chart.addElement(
                  `${q.questionLabel}_${q.questionID}_${Date.now()}_${
                    this.count
                  }`,
                  {
                    label:
                      q.questionLabel.length > 18
                        ? `${q.questionLabel.substring(0, 18)}...`
                        : q.questionLabel,
                  }
                );
                if (q.conditionsAnswer.hascompute) {
                  q.conditionsAnswer.computeCondition.notmatch.node =
                    this.chart.addElement(
                      `${q.questionLabel}_${
                        q.questionID
                      }_${Date.now()}_freetext_notmatch_node_${this.count}`,
                      {
                        label: "ไม่ตรงเงื่อนไข",
                      }
                    );
                  q.conditionsAnswer.computeCondition.match.map((c, ic) => {
                    let operationtext = this.operationlist.find(
                      (op) => op.operation === c.operation
                    );
                    let opname = `คะแนน: ${operationtext.text} ${
                      c.operation === "><" || c.operation === "<>"
                        ? `${c.value_from} และ ${c.value_to}`
                        : c.value
                    }`;
                    c.node = this.chart.addElement(
                      `${q.questionLabel}_${
                        q.questionID
                      }_${Date.now()}_freetext_${ic}_${Date.now()}_${
                        c.operation
                      }_${this.count}`,
                      {
                        label: opname,
                      }
                    );
                  });
                }
              }
              break;
          }
        }
      });
      for (const key in allnode) {
        const element = allnode[key];
        if (element.questionType !== "end") {
          if (element.indexing === 0) {
            start.leadsTo(element.node);
          }
          switch (element.conditionType) {
            case "freetext":
              {
                if (element.conditionsAnswer.hascompute) {
                  element.node.leadsTo(
                    element.conditionsAnswer.computeCondition.notmatch.node
                  );
                  let nextnotmatchnode = allnode.find(
                    (nt) =>
                      nt.questionID ===
                      element.conditionsAnswer.computeCondition.notmatch
                        .nextQuestionID
                  );
                  if (nextnotmatchnode) {
                    element.conditionsAnswer.computeCondition.notmatch.node.leadsTo(
                      nextnotmatchnode.node
                    );
                  }
                  element.conditionsAnswer.computeCondition.match.map((cp) => {
                    element.node.leadsTo(cp.node);
                    let nextnode = allnode.find(
                      (nt) => nt.questionID === cp.nextQuestionID
                    );
                    if (nextnode) {
                      cp.node.leadsTo(nextnode.node);
                    }
                  });
                } else {
                  let nextnode = allnode.find(
                    (nt) =>
                      nt.questionID ===
                      element.conditionsAnswer.defaultCondition.nextQuestionID
                  );
                  if (nextnode) {
                    element.node.leadsTo(nextnode.node);
                  }
                }
              }
              break;
            case "fixtext":
              {
                element.conditionsAnswer.map((c) => {
                  element.node.leadsTo(c.node);
                  if (c.hascompute) {
                    c.node.leadsTo(c.computeCondition.notmatch.node);
                    let nextnotmatchnode = allnode.find(
                      (nt) =>
                        nt.questionID ===
                        c.computeCondition.notmatch.nextQuestionID
                    );
                    if (nextnotmatchnode) {
                      c.computeCondition.notmatch.node.leadsTo(
                        nextnotmatchnode.node
                      );
                    }
                    c.computeCondition.match.map((cp) => {
                      c.node.leadsTo(cp.node);
                      let nextnode = allnode.find(
                        (nt) => nt.questionID === cp.nextQuestionID
                      );
                      if (nextnode) {
                        cp.node.leadsTo(nextnode.node);
                      }
                    });
                  } else {
                    let nextnode = allnode.find(
                      (nt) =>
                        nt.questionID === c.defaultCondition.nextQuestionID
                    );
                    if (nextnode) {
                      c.node.leadsTo(nextnode.node);
                    }
                  }
                });
              }
              break;
            case "number":
              {
                element.conditionsAnswer.map((c) => {
                  element.node.leadsTo(c.node);
                  if (c.hascompute) {
                    c.node.leadsTo(c.computeCondition.notmatch.node);
                    let nextnotmatchnode = allnode.find(
                      (nt) =>
                        nt.questionID ===
                        c.computeCondition.notmatch.nextQuestionID
                    );
                    if (nextnotmatchnode) {
                      c.computeCondition.notmatch.node.leadsTo(
                        nextnotmatchnode.node
                      );
                    }
                    c.computeCondition.match.map((cp) => {
                      c.node.leadsTo(cp.node);
                      let nextnode = allnode.find(
                        (nt) => nt.questionID === cp.nextQuestionID
                      );
                      if (nextnode) {
                        cp.node.leadsTo(nextnode.node);
                      }
                    });
                  } else {
                    let nextnode = allnode.find(
                      (nt) =>
                        nt.questionID === c.defaultCondition.nextQuestionID
                    );
                    if (nextnode) {
                      c.node.leadsTo(nextnode.node);
                    }
                  }
                });
              }
              break;
            case "multiselect":
              {
                if (element.conditionsAnswer.hascompute) {
                  element.node.leadsTo(
                    element.conditionsAnswer.computeCondition.notmatch.node
                  );
                  let nextnotmatchnode = allnode.find(
                    (nt) =>
                      nt.questionID ===
                      element.conditionsAnswer.computeCondition.notmatch
                        .nextQuestionID
                  );
                  if (nextnotmatchnode) {
                    element.conditionsAnswer.computeCondition.notmatch.node.leadsTo(
                      nextnotmatchnode.node
                    );
                  }
                  element.conditionsAnswer.computeCondition.match.map((cp) => {
                    element.node.leadsTo(cp.node);
                    let nextnode = allnode.find(
                      (nt) => nt.questionID === cp.nextQuestionID
                    );
                    if (nextnode) {
                      cp.node.leadsTo(nextnode.node);
                    }
                  });
                } else {
                  let nextnode = allnode.find(
                    (nt) =>
                      nt.questionID ===
                      element.conditionsAnswer.defaultCondition.nextQuestionID
                  );
                  if (nextnode) {
                    element.node.leadsTo(nextnode.node);
                  }
                }
              }
              break;
          }
        } else {
          element.node.leadsTo(end);
        }
      }
    },
  },
};
</script>
